// src/auth/AuthContext.tsx
import { createContext, useState, useEffect } from 'react';
import { OAuth2Client } from '@byteowls/capacitor-oauth2';
import { jwtDecode } from 'jwt-decode'; 
import { oauth2Config } from './Config';

export const AuthenticationContext = createContext<any>(null);

export const AuthProvider = ({ children }: any) => {
    const [accessToken, setAccessToken] = useState<string | null>(null);
    const [roles, setRoles] = useState<string[]>([]);
    const [initialized, setInitialized] = useState(false);
  
    useEffect(() => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        setAccessToken(token);
        const decoded: any = jwtDecode(token);
        const extractedRoles = decoded?.realm_access?.roles || [];
        setRoles(extractedRoles);
      }
      setInitialized(true);
    }, []);
  
    const login = async () => {
      try {
        const result = await OAuth2Client.authenticate(oauth2Config);
        const token = result?.accessToken;
        if (token) {
          localStorage.setItem('accessToken', token);
          setAccessToken(token);
          const decoded: any = jwtDecode(token);
          const extractedRoles = decoded?.realm_access?.roles || [];
          setRoles(extractedRoles);
        }
      } catch (err) {
        console.error('Authentication failed', err);
      }
    };
  
    const logout = async () => {
      await OAuth2Client.logout({
        appId: oauth2Config.appId,
        logoutUrl: "https://keycloak.as2alni.com/realms/askme/protocol/openid-connect/logout",
      },
    accessToken || '');
      localStorage.removeItem('accessToken');
      setAccessToken(null);
      setRoles([]);
    };
  
    return (
      <AuthenticationContext.Provider value={{ accessToken, roles, login, logout, initialized }}>
        {children}
      </AuthenticationContext.Provider>
    );
  };